import { attach, createEffect, createEvent, type EffectParams, type EventPayload, sample } from 'effector'
import { condition } from 'patronum'

import { portalProfileAPI } from '@/entities/profile/portal'
import { $lang } from '@/shared/lib/i18n'
import { type NotificationArgs, showNotificationFx } from '@/shared/ui'
import { createHideFx } from '@/shared/ui/modal'

export const showFx = createEffect<void, string>()
export const hideFx = createHideFx(showFx)

export const buttonClicked = createEvent<{ email: string }>()

const resetPasswordFx = attach({
    effect: portalProfileAPI.passwordReset,
    source: $lang,
    mapParams: (
        { email }: EventPayload<typeof buttonClicked>,
        lang
    ): EffectParams<typeof portalProfileAPI.passwordReset> => ({
        lang,
        email,
    }),
})

sample({
    clock: buttonClicked,
    target: resetPasswordFx,
})

sample({
    clock: resetPasswordFx.done,
    fn: ({ params }): NotificationArgs => ({ notification: 'password_reset_link_sent', email: params.email }),
    target: showNotificationFx,
})

const accountNotFoundError = createEvent()
const cannotResetError = createEvent()

condition({
    source: resetPasswordFx.fail,
    if: ({ error }) => error.code === 'account_not_found',
    then: accountNotFoundError,
    else: cannotResetError,
})

sample({
    clock: accountNotFoundError,
    fn: (): NotificationArgs => ({ notification: 'error_account_not_found' }),
    target: showNotificationFx,
})

sample({
    clock: cannotResetError,
    fn: (): NotificationArgs => ({ notification: 'error_cannot_reset_password' }),
    target: showNotificationFx,
})

sample({
    clock: resetPasswordFx.finally,
    target: hideFx,
})

export const $interactionDisabled = resetPasswordFx.pending
